import React, { useEffect, useRef } from "react"
import axios from "axios"
import PropTypes from "prop-types"
import useProfileStore from "../profileStore"

export default function VehicleInformation({ labels, hosts }) {
  const { headingVehicleInformation, labelVehicleRegistrationNumber, labelVehicleMake, labelVehicleModel, labelVehicleColour } = labels
  const {
    loadingLicensePlate,
    vehicleRegistrationNumber,
    setVehicleRegistrationNumber,
    vehicleMake,
    setVehicleMake,
    vehicleModel,
    setVehicleModel,
    vehicleColour,
    setVehicleColour,
    setLoadingLicensePlate,
  } = useProfileStore()

  useEffect(() => {
    verifyLicensePlate(vehicleRegistrationNumber)
  }, [vehicleRegistrationNumber])

  const delayTimeoutRef = useRef()
  const verifyLicensePlate = (value) => {
    if (!value || value === vehicleRegistrationNumber) return
    const VERIFY = `${hosts.ParkingBaseUrl}/api/v1/licenseplate/${vehicleRegistrationNumber}`
    clearTimeout(delayTimeoutRef.current)

    // Set a new timeout
    delayTimeoutRef.current = setTimeout(() => {
      setLoadingLicensePlate(true)
      if (value.length > 0) {
        axios
          .get(VERIFY)
          .then((res) => {
            return res.data
          })
          .then((data) => {
            for (const key in data) {
              switch (key) {
                case "make":
                  setVehicleMake(data.make)
                  break
                case "model":
                  setVehicleModel(data.model)
                  break
                case "color":
                  setVehicleColour(data.color)
                  break
                case "licensePlate":
                  setVehicleRegistrationNumber(data.licensePlate)
                  break
                default:
                  break
              }
            }
          })
          .catch((e) => {
            console.table("attempted to access License plate API but failed with error:", e)
            setLoadingLicensePlate(false)
          })
          .finally(() => {
            // this.setState({ loaderActive: false })
            setLoadingLicensePlate(false)
          })
      }
    }, 1000)
  }

  return (
    <div className="form--profile__essentials">
      <div className="form__section form__section--no-border clearfix">
        <h4>{headingVehicleInformation}</h4>

        <div className="form__section__inner">
          <div className={`form__field form__field--text ${vehicleRegistrationNumber ? "is-filled" : ""}`}>
            <span className="form__valid"></span>
            <input
              id="VehicleRegistrationNumber"
              className="form__item "
              name="VehicleRegistrationNumber"
              type="text"
              value={vehicleRegistrationNumber}
              onChange={(e) => {
                setVehicleRegistrationNumber(e.target.value.toUpperCase())
              }}
              placeholder=""
            ></input>
            <label htmlFor="VehicleRegistrationNumber" className="form__label">
              <span className="form__label__text">
                {labelVehicleRegistrationNumber}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
            {loadingLicensePlate ? <div className={"input-spinner"}></div> : undefined}
          </div>

          <div className={`form__field form__field--text ${vehicleMake ? "is-filled" : ""}`}>
            <span className="form__valid"></span>
            <input
              id="VehicleMake"
              className="form__item "
              name="VehicleMake"
              type="text"
              value={vehicleMake}
              onChange={(e) => {
                setVehicleMake(e.target.value)
              }}
              placeholder=""
            ></input>
            <label htmlFor="VehicleMake" className="form__label">
              <span className="form__label__text">
                {labelVehicleMake}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>

          <div className={`form__field form__field--text ${vehicleModel ? "is-filled" : ""}`}>
            <span className="form__valid"></span>
            <input
              id="VehicleModel"
              className="form__item "
              name="VehicleModel"
              type="text"
              value={vehicleModel}
              onChange={(e) => {
                setVehicleModel(e.target.value)
              }}
              placeholder=""
            ></input>
            <label htmlFor="VehicleModel" className="form__label">
              <span className="form__label__text">
                {labelVehicleModel}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>

          <div className={`form__field form__field--text ${vehicleColour ? "is-filled" : ""}`}>
            <span className="form__valid"></span>
            <input
              id="VehicleColour"
              className="form__item "
              name="VehicleColour"
              type="text"
              value={vehicleColour}
              onChange={(e) => {
                setVehicleColour(e.target.value)
              }}
              placeholder=""
            ></input>
            <label htmlFor="VehicleColour" className="form__label">
              <span className="form__label__text">
                {labelVehicleColour}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

VehicleInformation.propTypes = {
  labels: PropTypes.object.isRequired,
  hosts: PropTypes.object.isRequired,
}
